import React from "react";
import { Link } from "react-router-dom";
import { i18n } from "../../translate/i18n";
import { MASTER_HOME } from "../../helpers/masterUser";

export default function MasterPageBreadcrumb({ title, breadcrumbs = [] }) {
	const appName = process.env.REACT_APP_NOME || "NotificaMe";

	return (
		<div className="mb-4 flex flex-wrap items-center gap-2 print:hidden">
			<h4 className="m-0 text-lg font-semibold text-default-900 dark:text-default-50">
				{title}
			</h4>
			{breadcrumbs.length > 0 && (
				<nav
					className="ms-auto hidden items-center gap-2 text-sm font-semibold md:flex"
					aria-label="Breadcrumb"
				>
					<Link
						to={MASTER_HOME}
						className="text-sm font-medium text-default-600 hover:text-primary dark:text-default-400"
					>
						{appName}
					</Link>
					<span className="text-default-400" aria-hidden="true">
						/
					</span>
					{breadcrumbs.map((item, index) => {
						const label = item.labelKey ? i18n.t(item.labelKey) : item.label;
						const isLast = index === breadcrumbs.length - 1;
						return (
							<span key={item.to || label || index} className="flex items-center gap-2">
								{item.to && !isLast ? (
									<Link
										to={item.to}
										className="text-sm font-medium text-default-600 hover:text-primary dark:text-default-400"
									>
										{label}
									</Link>
								) : (
									<span
										className="text-sm font-medium text-default-800 dark:text-default-200"
										aria-current={isLast ? "page" : undefined}
									>
										{label}
									</span>
								)}
								{!isLast && (
									<span className="text-default-400" aria-hidden="true">
										/
									</span>
								)}
							</span>
						);
					})}
				</nav>
			)}
		</div>
	);
}
